<script>
import SpellCheckedText from "@/components/SpellCheckedText.vue";
import { formatNumber, calculateTotalYears } from "@/utils/proposalValidation";
import PhotoBox from "@/components/PhotoBox.vue";
import bookIcon from "@/assets/bookIcon.png";
import arrowCircleIcon from "@/assets/arrowCircleIcon.png";
import globeIcon from "@/assets/globeIcon.png";

export default {
    name: "ResumeTemp4",
    components: {
        SpellCheckedText,
        PhotoBox
    },
    props: {
        resume: { type: Object, required: true },
        pageGap: { type: Boolean, default: true },
        startPage: { type: Number, default: 1 },
    },
    data() {
        return {
            bookIcon,
            arrowCircleIcon,
            globeIcon,
			memberPages:[],
        };
    },
    computed: {},
    methods: {
        formatNumber,
        calculateTotalYears,
		async m_getResumeData(teamMemberId) {
		    let resumeData=await this.$store.dispatch('getResumeData', teamMemberId);
		    return resumeData;
		},
  async m_memberPages() {
    const membersWithData = [];

    for (const member of this.resume.members) {
        let resumeData = await this.m_getResumeData(member.teamMemberId);

        let parsedResumeData = resumeData;
        if (typeof parsedResumeData === 'string') {
            try {
                parsedResumeData = JSON.parse(parsedResumeData);
            } catch (e) {
                parsedResumeData = null;
            }
        }

        membersWithData.push({
            ...member,
            parsedResumeData
        });
    }

    const pages = [];
    for (let i = 0; i < membersWithData.length; i += 2) {
        pages.push(membersWithData.slice(i, i + 2));
    }

    this.memberPages = pages;
}		
    },
watch: {
  'resume.members': {
    deep: true,
    immediate: true,
    handler() {
      this.m_memberPages();
    }
  },
  'resume.members.length'(val) {
    if (val > 0) this.m_memberPages();
  },
  '$store.state.members.data': {
    deep: true,
    handler() {
      this.m_memberPages();
    }
  }
}	
};
</script>

<template>
    <div class="main-container" :style="{
        gap: pageGap ? '20px' : '0px',
        '--header-color': resume.style.colorScheme.header,
        '--body-color': resume.style.colorScheme.body,
        '--footer-color': resume.style.colorScheme.footer,
        '--heading-color': resume.style.heading.color,
        '--nameSec-color': resume.style.colorScheme.nameSec,
        '--expSec-color': resume.style.colorScheme.expSec,
        '--heading-size': resume.style.heading.size + 'px',
        '--heading-weight': resume.style.heading.bold ? 'bold' : 'normal',
        '--heading-style': resume.style.heading.italic ? 'italic' : 'normal',
        '--heading-decoration': resume.style.heading.underline ? 'underline' : 'none',
        '--heading-font': resume.style.heading.font,
        '--label-color': resume.style.label.color,
        '--label-size': resume.style.label.size + 'px',
        '--label-weight': resume.style.label.bold ? 'bold' : 'normal',
        '--label-style': resume.style.label.italic ? 'italic' : 'normal',
        '--label-decoration': resume.style.label.underline ? 'underline' : 'none',
        '--label-font': resume.style.label.font,
        '--text-color': resume.style.text.color,
        '--text-size': resume.style.text.size + 'px',
        '--text-weight': resume.style.text.bold ? 'bold' : 'normal',
        '--text-style': resume.style.text.italic ? 'italic' : 'normal',
        '--text-decoration': resume.style.text.underline ? 'underline' : 'none',
        '--text-font': resume.style.text.font,
    }">
        <div class="profile-container page-unit" v-for="(page, pageIndex) in memberPages" :key="pageIndex">
            <div class="banner top-banner">
                <h2>{{ resume.title }}</h2>
            </div>

            <div class="members-list">
                <div v-for="(member, mIndex) in page" :key="mIndex" class="cv-container">
                    <!-- Sidebar (From Temp2) -->
                    <div class="cv-info">
                        <div class="top-sec">
                            <div class="img-sec">
                                <PhotoBox v-if="member" class="photobox" :project="member"
                                    :bgColor="resume.style.colorScheme.body" type="profile" />
                            </div>

                            <div class="about">
                                <h2 class="name">
                                    <SpellCheckedText :value="member.teamMemberName || 'N/A'"
                                        @input="member.teamMemberName = $event" />
                                </h2>
                                <h3 v-if="member.role" class="role">
                                    <SpellCheckedText :value="member.role || 'N/A'" @input="member.role = $event" />
                                </h3>
                            </div>

                            <div class="details">
                                <div class="edu-container">
                                    <div class="heading">
                                        <img class="icon" :src="bookIcon" />
                                        <h2>EDUCATION</h2>
                                    </div>

                                    <div class="edu-sec">
                                        <div class="edu-list" v-if="member && member.parsedResumeData && member.parsedResumeData.education && member.parsedResumeData.education.length > 0"
                                            v-for="(edu, i) in (member && member.parsedResumeData && member.parsedResumeData.education)" :key="'edu-' + i">
                                            <img class="icon-circle" :src="arrowCircleIcon" />
                                            <div>
                                                <p class="degree">
                                                    <SpellCheckedText :value="edu.degree || 'N/A'"
                                                        @input="edu.degree = $event" />
                                                </p>
                                                <p class="uni">
                                                    <SpellCheckedText :value="edu.school || 'N/A'"
                                                        @input="edu.school = $event" />
                                                    <span v-if="edu.year"> ({{ edu.year }})</span>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="cert-container">
                                    <div class="heading">
                                        <img class="icon" :src="globeIcon" />
                                        <h2>AFFILIATIONS & CERTIFICATES</h2>
                                    </div>

                                    <ul class="cert-sec"
                                        v-if="(member.parsedResumeData && member.parsedResumeData.certifications && member.parsedResumeData.certifications.length > 0) || (member.certifications && member.certifications.length > 0)">
                                        <li class="cert"
                                            v-for="(cert, index) in ((member.parsedResumeData && member.parsedResumeData.certifications) || member.certifications || [])"
                                            :key="index">
                                            <SpellCheckedText :value="cert.name || cert || 'N/A'"
                                                @input="cert.name !== undefined ? cert.name = $event : member.certifications[index] = $event" />
                                            <span v-if="cert.issuer"> -
                                                <SpellCheckedText :value="cert.issuer" @input="cert.issuer = $event" />
                                            </span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="exp">
                            <SpellCheckedText
                                v-if="(member.parsedResumeData && member.parsedResumeData.positions && member.parsedResumeData.positions.length > 0) || member.yearsOfExperience"
                                :value="member.calculatedTotalExp !== undefined ? member.calculatedTotalExp : ((member.parsedResumeData && member.parsedResumeData.positions && member.parsedResumeData.positions.length) ? calculateTotalYears(member.parsedResumeData.positions) : (member.yearsOfExperience ? member.yearsOfExperience + ' YEARS EXPERIENCE' : '0 MONTHS EXPERIENCE'))"
                                @input="member.calculatedTotalExp = $event" />
                        </div>
                    </div>

                    <div class="experience-list">
                        <div v-for="(project, pIndex) in (member.projects || []).slice(0, 3)" :key="pIndex"
                            class="project-card"
                            :style="{ height: 'fit-content', maxHeight: `calc(100% / ${Math.min((member.projects || []).length, 3)})` }">
                            <div class="img-sec">
                                <PhotoBox v-if="project" class="photobox" :project="project" />
                                <div v-else class="imageBox" />
                            </div>
                            <div class="info-container">
                                <span class="label mr-1">
                                    <SpellCheckedText :value="project.projectName"
                                        @input="project.projectName = $event" />
                                </span> <br />
                                <span class="value">Size: <span class="text-nowrap">{{ project.projectSize ?
                                    `${formatNumber(project.projectSize)} SF` : "N/A"
                                        }}</span> | </span>
                                <span class="value">Value: {{ project.value ?
                                    `$${formatNumber(project.value)}` : "N/A" }} | </span>
                                <span class="value">Client:
                                    <SpellCheckedText :value="project.clientAccountName || 'N/A'"
                                        @input="project.clientAccountName = $event" /> |
                                </span>
                                <span class="value">
                                    Completion Date: {{ project.constructionCompletionDate ? new
                                        Date(project.constructionCompletionDate).getFullYear() : "N/A" }}
                                </span><br />
                                <span class="value">Scope:
                                    <SpellCheckedText :value="project.projectDetails || 'N/A'"
                                        @input="project.projectDetails = $event" />
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- FOOTER -->
            <div class="banner bottom-banner">
                <span class="page-number">{{ String(startPage + pageIndex).padStart(2, '0') }}</span>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.main-container {
    display: flex;
    flex-direction: column;
    width: 211mm;
    min-height: 296.83mm;
    position: relative;
    box-sizing: border-box;

    &:hover {
        .photobox :deep(.photo-overlay) {
            opacity: 1;
        }

        .photobox :deep(img) {
            opacity: 0.9;
        }
    }

    .profile-container {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        background: white;
        height: 296.83mm;
        overflow: hidden;

        .banner {
            display: flex;
            align-items: center;
            justify-content: center;
            min-height: 60px;
            position: relative;

            &.top-banner {
                background: var(--header-color);
            }

            &.bottom-banner {
                background: var(--footer-color);
            }

            h2 {
                font-size: 18px;
                color: white;
                margin-bottom: 0px;
                font-weight: 700;
                font-family: Helvetica;
            }

            .page-number {
                position: absolute;
                right: 15px;
                bottom: 10px;
                font-size: 14px;
                font-weight: 700;
                color: white;
                font-family: Helvetica;
            }
        }

        .members-list {
            flex: 1;
            display: flex;
            flex-direction: column;
            padding: 10px;
            gap: 20px;
            min-height: 0;

            .cv-container {
                flex: 1;
                display: flex;
                min-height: 0;
                overflow: hidden;
                gap: 20px;
                background: white;

                .cv-info {
                    width: 30%;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    background: var(--body-color);
                    height: 100%;
                    overflow: hidden;

                    .top-sec {
                        display: flex;
                        flex-direction: column;
                        flex: 1;
                        min-height: 0;
                        overflow: hidden;

                        .img-sec {
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            width: 120px;
                            height: 120px;
                            background: var(--body-color);
                            margin: auto;
                        }

                        .about {
                            background: var(--nameSec-color);
                            color: white;
                            text-transform: uppercase;
                            padding: 5px;
                            text-align: center;

                            .name {
                                font-size: 14px;
                                font-weight: 700;
                                font-family: Helvetica;
                                margin-bottom: 0px;
                            }

                            .role {
                                font-size: 12px;
                                font-weight: 400;
                                font-family: Helvetica;
                                margin-bottom: 0px;
                            }
                        }

                        .details {
                            flex: 1;
                            padding: 10px;
                            min-height: 0;
                            display: flex;
                            flex-direction: column;
                            overflow: hidden;

                            .icon {
                                color: #56c8ea;
                                flex-shrink: 0;
                                width: 18px;
                                height: 18px;
                            }

                            .icon-circle {
                                color: white;
                                flex-shrink: 0;
                                width: 18px;
                                height: 18px;
                            }

                            .heading {
                                display: flex;
                                gap: 10px;
                                padding-bottom: 3px;
                                border-bottom: 2px solid white;
                                margin-bottom: 5px;

                                h2 {
                                    font-size: var(--heading-size);
                                    font-weight: var(--heading-weight);
                                    font-family: var(--heading-font);
                                    font-style: var(--heading-style);
                                    text-decoration: var(--heading-decoration);
                                    color: var(--heading-color);
                                    margin-bottom: 0px;
                                }
                            }

                            .edu-sec {
                                min-height: 60px;

                                .edu-list {
                                    display: flex;
                                    flex-direction: row;
                                    gap: 10px;
                                    padding-top: 5px;
                                    margin-bottom: 5px;


                                    .degree {
                                        font-size: var(--label-size);
                                        font-weight: var(--label-weight);
                                        font-family: var(--label-font);
                                        font-style: var(--label-style);
                                        text-decoration: var(--label-decoration);
                                        color: var(--label-color);
                                        margin-bottom: 0px;
                                        line-height: 1.2;
                                    }

                                    .uni {
                                        font-size: var(--text-size);
                                        font-weight: var(--text-weight);
                                        font-family: var(--text-font);
                                        font-style: var(--text-style);
                                        text-decoration: var(--text-decoration);
                                        margin-bottom: 0px;
                                        color: var(--text-color);
                                        line-height: 1.2;
                                    }
                                }

                                .cert-container {
                                    flex: 1;
                                    display: flex;
                                    flex-direction: column;
                                    min-height: 0;
                                    overflow: hidden;
                                    margin-top: 5px;
                                }

                                .cert-sec {
                                    flex: 1;
                                    display: flex;
                                    flex-direction: column;
                                    padding: 5px 0px;
                                    padding-left: 20px;
                                    margin-bottom: 0px;
                                    overflow: hidden;

                                    .cert {
                                        font-size: var(--text-size);
                                        font-weight: var(--text-weight);
                                        font-family: var(--text-font);
                                        font-style: var(--text-style);
                                        text-decoration: var(--text-decoration);
                                        color: var(--text-color);
                                        margin-bottom: 5px;
                                    }
                                }
                            }
                        }
                    }

                    .exp {
                        background: var(--expSec-color);
                        padding: 8px 5px 4px 5px;
                        text-align: center;
                        margin-top: 5px;
                        font-size: 12px;
                        min-height: 23.96px;
                        font-weight: 700;
                        color: white;
                        font-family: Helvetica;
                        line-height: 1;
                    }
                }

                .experience-list {
                    flex: 1;
                    display: flex;
                    flex-direction: column;
                    background: var(--body-color);
                    padding: 15px 10px 0px 10px;
                    min-height: 0;
                    overflow: hidden;

                    .project-card {
                        display: flex;
                        gap: 15px;

                        &:last-child {
                            margin-bottom: 0px;
                        }

                        .img-sec {
                            width: 150px;
                            height: 120px;
                            margin-bottom: 15px;

                            img {
                                width: 100%;
                                height: 100%;
                                object-fit: fill;
                            }

                            .imageBox {
                                width: 100%;
                                height: 100%;
                                background: white;
                            }
                        }

                        .info-container {
                            flex: 1;
                            min-height: 0;
                            overflow: hidden;
                            line-height: 1.2;
                            margin-bottom: 15px;

                            .label {
                                font-weight: var(--label-weight);
                                font-size: var(--label-size);
                                font-family: var(--label-font);
                                font-style: var(--label-style);
                                text-decoration: var(--label-decoration);
                                color: var(--label-color);
                            }

                            .value {
                                margin-bottom: 0px;
                                color: var(--text-color);
                                font-size: var(--text-size);
                                font-family: var(--text-font);
                                font-weight: var(--text-weight);
                                font-style: var(--text-style);
                                text-decoration: var(--text-decoration);
                                overflow: hidden;
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>
